import React,{useState} from 'react'
import "../Styles/Projects.css"
import {ProjectImages} from "./ProjectImages"
import {FaCode, FaGithub} from 'react-icons/fa'

function Projects() {

    const [visible, setVisible] = useState(6)

    const showMoreItems = () =>{
        setVisible((prevValue) => prevValue + 6 )
    }



    return (
        <section className='projects section' id="projects">
            <div className='circle projects_circleOne'></div>
            <div className='circle projects_circleThree'></div>

            <h2 className='section_title'>Projects</h2>

            <div className='projectsContainer bd_grid'>
                {
                    
                    ProjectImages && 
                    ProjectImages.slice(0, visible).map((image,text)=>(
                        <div className='projectImg' key ={image.Id}>
                            <img src={image.imgSrc} alt='' />
                                 
                            <h3 className='text'>{image.text}<a href={image.href}><FaGithub className='git'  /></a>
                            <a href={image.web}><FaCode className='code'/></a></h3>
                        
              
 
                                  
                        </div>
                
                        
                    ))
                 
                    }          
                     
            </div>
            <button onClick={showMoreItems} className='button'>Load more</button>
            
        </section>

    )
}

export {Projects}
